import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Shield, Scale } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

const SECTIONS = [
  {
    n: "01",
    t: "Allgemeine Hinweise",
    body: (
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen.
        In dieser Datenschutzerklärung informieren wir Sie darüber, welche
        personenbezogenen Daten beim Besuch dieser Website erhoben werden, zu
        welchen Zwecken sie verarbeitet werden und welche Rechte Ihnen zustehen.
      </p>
    ),
  },
  {
    n: "02",
    t: "Verantwortliche Stelle",
    body: (
      <>
        <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
        <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 px-6 py-5">
          <div className="font-display text-base font-semibold text-slate-900">
            Kolagebäudereinigung Kristian Kola
          </div>
          <div className="mt-1 text-sm text-slate-600 leading-relaxed">
            Augsburger Str. 26<br />
            86157 Augsburg<br />
            Deutschland
          </div>
          <div className="mt-4 grid sm:grid-cols-2 gap-y-1 gap-x-6 text-sm">
            <div>
              <span className="text-slate-500">Telefon: </span>
              <a
                href="tel:+4917624458820"
                className="text-slate-900 font-medium hover:text-sky-700"
              >
                +49 176 2445 8820
              </a>
            </div>
            <div>
              <span className="text-slate-500">E-Mail: </span>
              <a
                href="mailto:info@kola-reinigung.de"
                className="text-slate-900 font-medium hover:text-sky-700"
              >
                info@kola-reinigung.de
              </a>
            </div>
          </div>
        </div>
      </>
    ),
  },
  {
    n: "03",
    t: "Erhebung und Speicherung personenbezogener Daten beim Besuch der Website",
    body: (
      <>
        <p>
          Beim Aufrufen dieser Website werden durch den Hosting-Anbieter
          automatisch Informationen erfasst und in sogenannten Server-Logfiles
          gespeichert. Erfasst werden können insbesondere:
        </p>
        <ul className="mt-4 space-y-2 list-disc list-outside pl-5 marker:text-sky-500">
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Browsertyp und Browserversion</li>
          <li>verwendetes Betriebssystem</li>
          <li>Referrer-URL</li>
          <li>Hostname des zugreifenden Rechners</li>
        </ul>
        <p className="mt-4">
          Die Verarbeitung dieser Daten erfolgt zur Gewährleistung eines
          störungsfreien Betriebs der Website sowie zur Systemsicherheit und
          -stabilität. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
        </p>
      </>
    ),
  },
  {
    n: "04",
    t: "Kontaktformular",
    body: (
      <>
        <p>
          Wenn Sie uns über das Kontaktformular eine Anfrage senden, werden die
          von Ihnen eingegebenen Daten verarbeitet, um Ihre Anfrage zu
          bearbeiten und Sie zu kontaktieren. Dabei handelt es sich insbesondere
          um folgende Angaben:
        </p>
        <ul className="mt-4 space-y-2 list-disc list-outside pl-5 marker:text-sky-500">
          <li>Name</li>
          <li>Telefonnummer</li>
          <li>E-Mail-Adresse</li>
          <li>Nachricht / Anliegen</li>
        </ul>
        <p className="mt-4">
          Die Verarbeitung dieser Daten erfolgt zur Bearbeitung Ihrer Anfrage
          und zur Durchführung vorvertraglicher Maßnahmen bzw. zur
          Kontaktaufnahme. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO sowie
          Art. 6 Abs. 1 lit. f DSGVO, soweit eine allgemeine Kontaktanfrage
          vorliegt.
        </p>
        <p className="mt-4">
          Die im Kontaktformular übermittelten Daten werden nicht ohne Ihre
          Einwilligung an Dritte weitergegeben, es sei denn, dies ist gesetzlich
          erlaubt oder zur Bearbeitung Ihrer Anfrage erforderlich.
        </p>
      </>
    ),
  },
  {
    n: "05",
    t: "Kontaktaufnahme per E-Mail oder Telefon",
    body: (
      <p>
        Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden Ihre Angaben
        und die daraus hervorgehenden personenbezogenen Daten zum Zweck der
        Bearbeitung Ihrer Anfrage gespeichert und verarbeitet. Diese Daten geben
        wir nicht ohne Ihre Einwilligung weiter, sofern keine gesetzliche
        Verpflichtung besteht.
      </p>
    ),
  },
  {
    n: "06",
    t: "Google Maps",
    body: (
      <>
        <p>
          Diese Website bindet Google Maps zur Darstellung unseres Standorts
          ein. Anbieter ist Google Ireland Limited, Gordon House, Barrow Street,
          Dublin 4, Irland.
        </p>
        <p className="mt-4">
          Zur Nutzung von Google Maps ist es erforderlich, dass Ihre IP-Adresse
          sowie gegebenenfalls weitere technische Informationen an Google
          übermittelt werden. Diese Daten können auch auf Servern von Google in
          den USA verarbeitet werden. Auf diese Datenverarbeitung haben wir
          keinen vollständigen Einfluss.
        </p>
        <p className="mt-4">
          Die Einbindung von Google Maps erfolgt im Interesse einer
          ansprechenden Darstellung unseres Online-Angebots und einer einfachen
          Auffindbarkeit unseres Unternehmens. Rechtsgrundlage ist Art. 6 Abs.
          1 lit. f DSGVO. Sofern eine Einwilligungslösung eingesetzt wird und
          Google Maps erst nach Zustimmung geladen wird, ist Rechtsgrundlage
          Art. 6 Abs. 1 lit. a DSGVO.
        </p>
        <p className="mt-4">
          Weitere Informationen zur Datenverarbeitung durch Google finden Sie
          unter:{" "}
          <a
            href="https://policies.google.com/privacy?hl=de"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sky-700 font-medium hover:text-sky-900 underline decoration-sky-300 underline-offset-4"
          >
            policies.google.com/privacy
            <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </p>
      </>
    ),
  },
  {
    n: "07",
    t: "Speicherdauer",
    body: (
      <p>
        Wir speichern personenbezogene Daten nur so lange, wie dies zur
        Erfüllung der jeweiligen Zwecke erforderlich ist oder gesetzliche
        Aufbewahrungsfristen bestehen. Anschließend werden die Daten gelöscht,
        sofern keine weitere rechtliche Grundlage für die Speicherung besteht.
      </p>
    ),
  },
  {
    n: "08",
    t: "Ihre Rechte",
    body: (
      <>
        <p>Sie haben im Rahmen der gesetzlichen Vorschriften das Recht:</p>
        <ul className="mt-4 space-y-2 list-disc list-outside pl-5 marker:text-sky-500">
          <li>auf Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten gemäß Art. 15 DSGVO,</li>
          <li>auf Berichtigung unrichtiger oder Vervollständigung unvollständiger Daten gemäß Art. 16 DSGVO,</li>
          <li>auf Löschung Ihrer bei uns gespeicherten Daten gemäß Art. 17 DSGVO,</li>
          <li>auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO,</li>
          <li>auf Datenübertragbarkeit gemäß Art. 20 DSGVO,</li>
          <li>auf Widerspruch gegen die Verarbeitung gemäß Art. 21 DSGVO.</li>
        </ul>
        <p className="mt-4">
          Außerdem haben Sie das Recht, sich bei einer
          Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
          personenbezogenen Daten zu beschweren.
        </p>
      </>
    ),
  },
  {
    n: "09",
    t: "Widerruf Ihrer Einwilligung",
    body: (
      <p>
        Sofern eine Verarbeitung auf Ihrer Einwilligung beruht, können Sie eine
        einmal erteilte Einwilligung jederzeit mit Wirkung für die Zukunft
        widerrufen.
      </p>
    ),
  },
  {
    n: "10",
    t: "SSL- bzw. TLS-Verschlüsselung",
    body: (
      <p>
        Diese Website nutzt aus Sicherheitsgründen und zum Schutz der
        Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung.
      </p>
    ),
  },
  {
    n: "11",
    t: "Aktualität und Änderung dieser Datenschutzerklärung",
    body: (
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
        stets den aktuellen rechtlichen Anforderungen entspricht oder um
        Änderungen unserer Website und Leistungen in der Datenschutzerklärung
        umzusetzen.
      </p>
    ),
  },
];

export default function Datenschutz() {
  return (
    <main data-testid="datenschutz-page" className="min-h-screen bg-white">
      <Navbar />

      {/* Hero header */}
      <section className="relative pt-36 md:pt-44 pb-12 md:pb-16 bg-gradient-to-b from-slate-50 via-white to-white border-b border-slate-100 overflow-hidden">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              "radial-gradient(#0f172a 1px, transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />
        <div className="pointer-events-none absolute -top-40 right-0 w-[500px] h-[500px] rounded-full bg-sky-100/50 blur-3xl" />

        <div className="relative mx-auto max-w-4xl px-6 md:px-10">
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-sky-700 transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>

          <div className="inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white px-4 py-1.5 mb-6 shadow-sm">
            <Shield className="w-3.5 h-3.5 text-sky-600" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-700">
              Rechtliches
            </span>
          </div>

          <h1 className="font-display text-4xl sm:text-5xl lg:text-[56px] font-semibold tracking-tight leading-[1.02] text-slate-900">
            Datenschutz<span className="italic font-normal text-slate-400">erklärung</span>
            <span className="text-sky-500">.</span>
          </h1>
          <p className="mt-5 text-slate-600 text-base md:text-lg max-w-2xl leading-relaxed">
            Informationen zur Verarbeitung Ihrer personenbezogenen Daten beim
            Besuch dieser Website sowie zu Ihren Rechten nach der DSGVO.
          </p>

          <div className="mt-8 inline-flex items-center gap-2 text-xs text-slate-500">
            <Scale className="w-3.5 h-3.5 text-slate-400" />
            Gültig ab Veröffentlichung. Letzte Aktualisierung: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="relative py-16 md:py-24 bg-white">
        <div className="mx-auto max-w-4xl px-6 md:px-10">
          {/* Inline TOC */}
          <nav
            aria-label="Inhaltsverzeichnis"
            className="hidden md:block rounded-2xl border border-slate-200 bg-slate-50/50 p-6 mb-14"
          >
            <div className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500 mb-4">
              Inhalt
            </div>
            <ol className="grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm">
              {SECTIONS.map((s) => (
                <li key={s.n}>
                  <a
                    href={`#section-${s.n}`}
                    className="group inline-flex items-baseline gap-3 text-slate-700 hover:text-sky-700 transition-colors"
                  >
                    <span className="font-display text-xs text-slate-400 group-hover:text-sky-600 tracking-widest">
                      {s.n}
                    </span>
                    <span className="border-b border-transparent group-hover:border-sky-300">
                      {s.t}
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          {/* Sections */}
          <div className="space-y-14 md:space-y-16">
            {SECTIONS.map((s) => (
              <article
                key={s.n}
                id={`section-${s.n}`}
                className="scroll-mt-32 group"
              >
                <div className="flex items-baseline gap-5 mb-4">
                  <span className="font-display text-3xl md:text-4xl font-semibold tracking-tight bg-gradient-to-br from-slate-900 via-slate-700 to-sky-600 bg-clip-text text-transparent shrink-0">
                    {s.n}
                  </span>
                  <h2 className="font-display text-xl md:text-2xl font-semibold text-slate-900 tracking-tight leading-snug">
                    {s.t}
                  </h2>
                </div>
                <div className="ml-0 md:ml-[60px] prose prose-slate max-w-none text-[15px] md:text-base text-slate-700 leading-relaxed [&_p]:mb-0">
                  {s.body}
                </div>
              </article>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="mt-20 pt-10 border-t border-slate-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
            <p className="text-sm text-slate-600 max-w-md">
              Fragen zum Datenschutz?{" "}
              <a
                href="mailto:info@kola-reinigung.de"
                className="font-semibold text-sky-700 hover:text-sky-900 underline decoration-sky-300 underline-offset-4"
              >
                info@kola-reinigung.de
              </a>
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-sky-600 text-white px-5 py-3 text-sm font-semibold transition-colors shadow-lg shadow-slate-900/10"
            >
              <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
